"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./GTMOverlay.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GTMOverlay = function GTMOverlay(_ref) {
  var className = _ref.className,
      id = _ref.id;
  var classes = (0, _classnames.default)('gtm-overlay', _defineProperty({}, className, className));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    id: id
  });
};

var _default = GTMOverlay;
exports.default = _default;